import { useContext, useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { SessionContext } from 'contexts/session';
import Icon from 'components/icons';
import { AppContext } from 'contexts/app';
import usePath from 'hooks/usePath';

const Container = styled.div``;

const Title = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  font-weight: 700;
  font-size: 17px;
  line-height: 17px;
  color: ${({ theme }) => theme.default.colors.palette.Business_DarkThemeGeneralBackground};
`;

const License = styled.div`
  width: 100%;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: ${({ theme }) => theme.default.colors.palette.Business_LightThemeGreyDarker};
  span {
    font-weight: 700;
    color: ${({ theme }) => theme.default.colors.palette.Business_DarkThemeGeneralBackground};
  }
`;

const HeaderInfo = (): JSX.Element => {
  const {
    licenses_available,
    showDrawer,
    setVisibiltyDrawer,
    showNotesDrawer,
    setShowNotesDrawer,
    showActivityLogDrawer,
    setShowActivityLogDrawer,
    account,
  } = useContext(SessionContext);
  const { backButton } = useContext(AppContext);
  const { title } = usePath();
  const headerLabel = useMemo(
    () => backButton?.label || title || account?.name,
    [backButton?.label, title, account?.name]
  );
  const activeDrawer = useMemo(
    () => showDrawer || showNotesDrawer || showActivityLogDrawer,
    [showDrawer, showNotesDrawer, showActivityLogDrawer]
  );
  const showBackIcon = useMemo(
    () => backButton?.action || activeDrawer,
    [backButton?.action, activeDrawer]
  );

  const handleCloseDrawer = () => {
    if (showDrawer) setVisibiltyDrawer(false);
    if (showNotesDrawer) setShowNotesDrawer(false);
    if (showActivityLogDrawer) setShowActivityLogDrawer(false);
  };

  return (
    <Container>
      {headerLabel && (
        <Title>
          {showBackIcon && (
            <Icon
              icon="ArrowLeft"
              style={{ marginRight: 5 }}
              color={'#A793F6'}
              onClick={activeDrawer ? handleCloseDrawer : backButton?.action}
            />
          )}
          {headerLabel}
        </Title>
      )}
      {!isMobile && licenses_available !== undefined && (
        <License>
          Licenses available:
          <span>{licenses_available === true ? 'Unlimited' : licenses_available}</span>
        </License>
      )}
    </Container>
  );
};

export default HeaderInfo;
